import { LinkedinCards } from "domain/entities/linkedincards";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface LinkedinCardsState {
  selectedCard: LinkedinCards | null;
  setSelectedCard: (item: LinkedinCards | null) => void;
  resetSelectedCard: () => void;
}

export const useLinkedinCardsSelectedStore =
  create<LinkedinCardsState>()(
    devtools(
      (set) => ({
        selectedCard: null,

        setSelectedCard: (item) =>
          set({ selectedCard: item }),

        resetSelectedCard: () =>
          set({ selectedCard: null }),
      }),
      { name: "LinkedinCardsSelected" }
    )
  );